import ApiService from './api';
import { KycStartResult, KycStatusResult } from '@/types';

export class KycService {
  /**
   * 发起平台 KYC 认证（MoR 模式，Didit）
   * POST /api/v1/merchant/kyc/start
   * 返回 Didit 托管验证会话地址 redirect_url，前端跳转后完成验证。
   */
  static async startKyc(): Promise<KycStartResult> {
    const response = await ApiService.post<{ data: KycStartResult }>('/merchant/kyc/start', {});
    return response.data.data;
  }

  /**
   * 查询平台 KYC 状态
   * GET /api/v1/merchant/kyc/status
   */
  static async getKycStatus(): Promise<KycStatusResult> {
    const response = await ApiService.get<{ data: KycStatusResult }>('/merchant/kyc/status');
    return response.data.data;
  }
}

export default KycService;
